import React from 'react';
import {Form} from 'formik';
import {FormattedMessage} from 'react-intl';
import styles from './styles.module.scss';
import Button from '../../components/Button';

const Step17View = () => {
  return (
    <Form className={styles.formContainer}>
        <div className={styles.titleBold}>
          <FormattedMessage
            id='step17.form.title'
          />
        </div>
      <div className={styles.text}>
        <FormattedMessage
          id={'step17.section1.text.1'}
          defaultMessage={'Lorem ipsum sit dolor amet'}
        />
      </div>
      <div className={styles.text}>
        <FormattedMessage
          id={'step17.section1.text.2'}
          defaultMessage={'Lorem ipsum sit dolor amet'}
        />
      </div>
      <div className={`${styles.text} ${styles.marginTop} ${styles.marginBottom}`}>
        <FormattedMessage
          id={'step17.section1.text.3'}
          defaultMessage={'Lorem ipsum sit dolor amet'}
        />
      </div>
        <div className={styles.titleBold}>
          <FormattedMessage
            id='step17.section2.title'
          />
        </div>
      <div className={styles.text}>
        <FormattedMessage
          id={'step17.section2.text.1'}
          defaultMessage={'Lorem ipsum sit dolor amet'}
        />
      </div>
      <div className={styles.text}>
        <FormattedMessage
          id={'step17.section2.text.2'}
          defaultMessage={'Lorem ipsum sit dolor amet'}
        />
      </div>
      <Button
        type='submit'
        label={(
          <FormattedMessage
            id='common.form.button.save'
            defaultMessage='Save'
          />
        )}
        className={styles.marginTop}
      />
    </Form>
  )
};

export default Step17View;
